<script setup lang="ts">
import { computed } from "vue";

import logoLightUrl from "../../assets/logo-light.png";
import logoUrl from "../../assets/logo.png";
import { useTheme } from "../composables/useTheme";

interface Properties {
  class?: string;
}

withDefaults(defineProps<Properties>(), {
  class: "h-24 md:h-32 w-auto shrink-0",
});

const { theme } = useTheme();

const source = computed(() => (theme.value === "light" ? logoLightUrl : logoUrl));
</script>

<template>
  <img alt="Schnittpunkt Lehrte" :class="$props.class" loading="eager" :src="source" />
</template>
